import { render, staticRenderFns } from "./DeliverySummary.vue?vue&type=template&id=05a426fe&scoped=true&"
import script from "./DeliverySummary.vue?vue&type=script&lang=js&"
export * from "./DeliverySummary.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySummary.vue?vue&type=style&index=0&id=05a426fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a426fe",
  null
  
)

export default component.exports